import { Tooltip } from "@mui/material";

const truncateText = (text, maxLines = 2) => {
  const lineHeight = 1.2; // Adjust this based on your actual line - height
  const maxChars = Math.floor(10 * maxLines * lineHeight); // Rough estimate, adjust as needed
  if (text && text.length > maxChars) {
    return (
      <Tooltip title={text}>
        <span>{text.slice(0, maxChars)}...</span>
      </Tooltip>
    );
  }
  return text || "-";
};

export default truncateText;
